import React from 'react';

export const FinalCTA: React.FC = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-orange-500 to-orange-600">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <div className="mb-12">
          <div className="relative overflow-hidden rounded-2xl shadow-2xl mb-8">
            <img
              src="https://public.readdy.ai/ai/img_res/63fc7dbdddf97278deeb1fd01b8d69b8.jpg"
              alt="Beautiful Garden Apartment Complex"
              className="w-full h-[400px] object-cover object-top"
            />
          </div>
        </div>

        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Sell Your Garden Apartments?
        </h2>
        <p className="text-2xl text-white/95 mb-8 leading-relaxed">
          Let's discuss your property and goals. We're here to provide honest feedback and fair offers.
        </p>
        <p className="text-xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
          Whether you're facing deferred maintenance, planning retirement, dealing with an inheritance, or simply ready to exit the multifamily business, we can help. Our team specializes in garden apartments and understands the unique aspects of these properties.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
          <a
            href="#get-offer"
            className="px-10 py-5 bg-white text-orange-600 font-bold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl text-lg whitespace-nowrap"
          >
            Get Your Cash Offer
          </a>
          <a
            href="tel:+1234567890"
            className="px-10 py-5 bg-gray-900 text-white font-bold rounded-lg hover:bg-gray-800 transition-all duration-300 shadow-lg hover:shadow-xl text-lg whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Call Now
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-white mb-2">500+</div>
            <div className="text-white/90">Properties Purchased</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-white mb-2">$200M+</div>
            <div className="text-white/90">Total Transactions</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="text-4xl font-bold text-white mb-2">30 Days</div>
            <div className="text-white/90">Average Closing Time</div>
          </div>
        </div>
      </div>
    </section>
  );
};